import Loading from "shared/components/Spin";
import { TEMPLATES } from "utils/constants";
import CollectionNeeds from "./CollectionNeeds";
import Comparison from "./Comparison";
import Contact from "./Contact";
import Contract from "./Contract";
import Default from "./Default";
import Documents from "./Documents";
import Fast from "./Fast";
import Quote from "./Quote";
import SelectProducts from "./SelectProducts";
import Upsells from "./Upsells";

const Templates = {
  Loading: Loading,
  [TEMPLATES.B2B.THEMES.B2B_LA_FOURGALE.CONTACT]: Contact,
  [TEMPLATES.B2B.THEMES.B2B_LA_FOURGALE.SUBSCRIPTION]: Contract,
  [TEMPLATES.B2B.THEMES.B2B_LA_FOURGALE.CONTRACT]: Documents,
  [TEMPLATES.B2B.THEMES.B2B_LA_FOURGALE.QUOTE]: Quote,
  [TEMPLATES.B2B.THEMES.B2B_LA_FOURGALE.FAST]: Fast,
  [TEMPLATES.B2B.THEMES.B2B_LA_FOURGALE.COLLECTION_NEEDS]: CollectionNeeds,
  [TEMPLATES.B2B.THEMES.B2B_LA_FOURGALE.SELECT_PRODUCTS]: SelectProducts,
  [TEMPLATES.B2B.THEMES.B2B_LA_FOURGALE.COMPARISON]: Comparison,
  [TEMPLATES.B2B.THEMES.B2B_LA_FOURGALE.UPSELLS]: Upsells,
  default: Default,
};
export default Templates;
